let interacted = false;

const handleInteraction = () => {
  interacted = true;
};

export const addElementInteractListeners = (ele: HTMLElement): void => {
  ele.addEventListener('scroll', handleInteraction);
  ele.addEventListener('keydown', handleInteraction);
  ele.addEventListener('click', handleInteraction);
  ele.addEventListener('touchstart', handleInteraction);
};

addElementInteractListeners(document.body);

export const isInteracted = (): boolean => interacted;
